import {
  faCouch, faTree, faHouse, faRoad, faLocationDot, faMap,
  faTrophy, faCrown, faBolt, faGlobe,
} from '@fortawesome/free-solid-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export interface League {
  number: number;
  name: string;
  category: string;
  icon: IconDefinition;
}

export const LEAGUES: League[] = [
  { number: 1,  name: 'Couch Crusher',          category: 'Warm-Up League',     icon: faCouch },
  { number: 2,  name: 'Park Pioneer',            category: 'Warm-Up League',     icon: faTree },
  { number: 3,  name: 'Neighborhood Warrior',    category: 'Hobby League',       icon: faHouse },
  { number: 4,  name: 'Asphalt Crusher',          category: 'Hobby League',       icon: faRoad },
  { number: 5,  name: 'Local Matador',           category: 'Competitive League', icon: faLocationDot },
  { number: 6,  name: 'Regional Regent',         category: 'Competitive League', icon: faMap },
  { number: 7,  name: 'Podium Contender',        category: 'Elite League',       icon: faTrophy },
  { number: 8,  name: 'Summit Seeker',            category: 'Elite League',       icon: faCrown },
  { number: 9,  name: 'Titan of Endurance',      category: 'Gods\' League',      icon: faBolt },
  { number: 10, name: 'NoWeakWeek World Champ',  category: 'Gods\' League',      icon: faGlobe },
];

/**
 * level_value 1  = Liga 1, Stufe 1 (Einstieg)
 * level_value 3  = Liga 1, Stufe 3 → nächster Sieg = Liga 2 Stufe 1
 * level_value 4  = Liga 2, Stufe 1
 * level_value 30 = Liga 10, Stufe 3 (Maximum)
 */
export function getLevelInfo(levelValue: number): { league: League; stufe: number } {
  const clamped = Math.max(1, Math.min(30, levelValue));
  const idx     = Math.floor((clamped - 1) / 3);  // 0 = Liga1, 9 = Liga10
  const stufe   = ((clamped - 1) % 3) + 1;        // 1 = Einstieg, 3 = kurz vor Aufstieg
  return { league: LEAGUES[idx], stufe };
}

export function levelValueOf(ligaNumber: number, stufe: number): number {
  return (ligaNumber - 1) * 3 + stufe;
}

// ── OnFire-Farbverlauf ──────────────────────────────────────────────────────

/**
 * Returns a 🔥 fire-gradient color based on onfire value.
 * Higher onfire = more intense red/orange.
 */
export function getEloColor(elo: number): string {
  if (elo >= 500) return '#ff4500';  // bright red
  if (elo >= 400) return '#ff6a00';  // orange-red
  if (elo >= 300) return '#ff8c00';  // dark orange
  if (elo >= 200) return '#ffb63c';  // warm gold
  if (elo >= 100) return '#ffc857';  // light gold
  return '#ffd97d';                  // pale gold
}

